function onScrollBannerDo() {
  let scrollingTop = window.pageYOffset || document.documentElement.scrollTop;
  let bannerHeight = document.querySelector(".banner").offsetHeight;

  if (document.documentElement.clientWidth > 768) {
    let layer_text = scrollingTop / 6;
    document.querySelectorAll(".parallax__layer-1, .parallax__layer-2, .parallax__layer-3")
      .forEach(layer => layer.style.transform = `translateY(-${layer_text}px)`);

    let layer_puf = scrollingTop / 4.9;
    document.querySelector(".parallax__layer-4").style.transform = `translateY(-${layer_puf}px)`;
  } else {
    document.querySelectorAll(".parallax__layer-1, .parallax__layer-2, .parallax__layer-3, .parallax__layer-4")
      .forEach(layer => layer.removeAttribute("style"));
  }

  let backgroundChangeElements = document.querySelectorAll(".category, .new-products, .customization, .events");

  if (scrollingTop > bannerHeight) {
    backgroundChangeElements.forEach(element => element.classList.remove("_background-change"));
  } else {
    backgroundChangeElements.forEach(element => element.classList.add("_background-change"));
  }
}

onScrollBannerDo();

window.addEventListener("scroll", onScrollBannerDo);
window.addEventListener("resize", onScrollBannerDo);
